// extracted by mini-css-extract-plugin
export default {"wrapper":"CardWrapper_wrapper__BwI6z","wrapper___selected":"CardWrapper_wrapper___selected__GQVyq"};